// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1is_n","title":"FrontImage_title__1RC0s"};